function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "plus");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Invision",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "plus",
  transform: "translate(0.625000, 0.375391)",
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.25,8.12460899 C16.25,8.46835852 15.9687495,8.74960899 15.625,8.74960899 L8.75,8.74960899 L8.75,15.624609 C8.75,15.9700775 8.47046852,16.25 8.125,16.25 C7.77953148,16.25 7.5,15.9683585 7.5,15.624609 L7.5,8.74960899 L0.625,8.74960899 C0.279531479,8.74960899 0,8.47031236 0,8.125 C0,7.78085887 0.279687643,7.49960899 0.625,7.49960899 L7.5,7.49960899 L7.5,0.624608994 C7.5,0.279140472 7.77953148,0 8.125,0 C8.47046852,0 8.75,0.279296637 8.75,0.624608994 L8.75,7.49960899 L15.625,7.49960899 C15.9687495,7.49960899 16.25,7.78085887 16.25,8.12460899 Z",
  id: "Path"
})));
const SvgIconPlus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-plus.e45fe0fa.svg";
export { ForwardRef as ReactComponent };